import { __awaiter, __rest } from '../_virtual/_tslib.js';

var singleCall = ((provider, ensData, func, ...data) => __awaiter(void 0, void 0, void 0, function* () {
  const _a = yield func.raw(ensData, ...data),
    {
      passthrough
    } = _a,
    rawData = __rest(_a, ["passthrough"]);
  const result = yield provider.call(Object.assign(Object.assign({}, rawData), {
    ccipReadEnabled: true
  })).catch(() => null);
  if (!result) return;
  if (passthrough) return func.decode(ensData, result, passthrough, ...data);
  return func.decode(ensData, result, ...data);
}));

export { singleCall as default };
